const CONTENT_GROUP_FORM_UPDATE_CONTENT =
  "page::content-group-form::update::content";
const CONTENT_GROUP_FORM_UPDATE_NAME = "page::content-group-form::update::name";

function contentGroupUpdateContentAction(content) {
  return {
    payload: content,
    type: CONTENT_GROUP_FORM_UPDATE_CONTENT,
  };
}

function contentGroupUpdateNameAction(name) {
  return {
    payload: name,
    type: CONTENT_GROUP_FORM_UPDATE_NAME,
  };
}

export {
  CONTENT_GROUP_FORM_UPDATE_CONTENT,
  CONTENT_GROUP_FORM_UPDATE_NAME,
  contentGroupUpdateContentAction,
  contentGroupUpdateNameAction,
};
